<template>
  <v-container
    v-shortkey.once="['esc']"
    fluid
    tag="section"
    class="py-0"
    @shortkey="escape"
  >
    <v-dialog
      v-model="dialog"
      :max-width="maxWidth"
      :persistent="persistent"
      :fullscreen="$vuetify.breakpoint.xs"
    >
      <v-overlay
        :value="loading"
      >
        <v-progress-circular
          indeterminate
          size="64"
        />
      </v-overlay>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-if="activatorOn"
          color="primary"
          dark
          class="mb-2"
          v-bind="attrs"
          v-on="on"
        >
          {{ dialogTitle }}
        </v-btn>
      </template>

      <validation-observer
        ref="form"
        v-slot="{ passes }"
      >
        <v-form
          @submit.prevent="passes(save)"
        >
          <v-card>
            <v-card-title
              class="grey lighten-3"
            >
              <v-icon v-if="icon" color="primary" v-text="icon" />
              <span class="text-h5 font-weight-regular ml-4">{{ dialogTitle }}</span>
            </v-card-title>

            <v-divider />

            <v-card-text class="mt-4">
              <v-container class="py-0">
                <!-- editform -->
                <slot name="editform" />
              </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions>
              <v-btn
                v-if="canDelete && !newItem"
                v-shortkey.once="['f8']"
                color="delete"
                @click="remove"
                @shortkey="remove"
              >
                {{ $t('delete') }}
              </v-btn>
              <v-spacer />
              <v-btn
                v-shortkey.once="['esc']"
                color="cancel"
                @click="escape"
                @shortkey="escape"
              >
                {{ $t('cancel') }}
              </v-btn>
              <v-btn
                v-shortkey.once="['f10']"
                dark
                color="save"
                type="submit"
                @shortkey="passes(save)"
              >
                {{ $t('save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </validation-observer>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    name: 'CumulusEditDialog',
    model: {
      prop: 'open',
      event: 'valuechange',
    },
    props: {
      icon: {
        type: String,
        default: '$edit',
      },
      title: {
        type: String,
        default: 'datas',
      },
      newItem: {
        type: Boolean,
        default: false,
      },
      open: {
        type: Boolean,
        default: false,
      },
      customTitle: {
        type: Boolean,
        default: false,
      },
      activatorOn: {
        type: Boolean,
        default: false,
      },
      maxWidth: {
        type: Number,
        default: 500,
      },
      canDelete: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      persistent: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        message: '',
        // formTitle: 'Szerkesztés',
      }
    },
    computed: {
      dialog: {
        get: function () {
          return this.open
        },
        set: function (value) {
          this.$emit('valuechange', value)
        },
      },
      dialogTitle () {
        console.log(this.$t(this.title))
        return !this.customTitle ? this.$t(this.newItem ? 'insert' : 'edit', { type: this.$t(this.title) }) : this.$t(this.title)
      },
    },
    watch: {
      dialog (val) {
        val || this.closeDialog()
      },
      open (val) {
        // console.log('change open : ' + this.dialog)
      },
    },
    methods: {
      addItem () {
        this.$emit('new')
      },
      save () {
        this.$emit('save')
        // this.closeDialog()
      },
      remove () {
        this.$emit('remove')
        // this.closeDialog()
      },
      escape () {
        // this.closeDialog()
        this.$emit('escape')
      },
      setErrors (e) {
        console.log('error')
        console.log(e)
        this.$refs.form.setErrors(e)
      },
      closeDialog () {
        this.dialog = false
      },
    },
  }
</script>
